"use strict";
// @ts-ignore
try {
    self['workbox:navigation-preload:7.0.0'] && _();
}
catch (e) { }
